<template>
    <div v-if="baggage" class="baggage-warning-content">
        <div>
            <p>{{ t({ key: 'warning.baggage_save_money', suffix: '.' }) }}</p>
        </div>
        <div class="mt-3">
            <p>
                {{
                    t({
                        key: 'shared.do_you_want_to_add_X',
                        values: [getBaggageLabel(baggage, false, true)],
                    })
                }}
            </p>
            <p v-if="price" class="mb-0">
                <span class="baggage-warning-content-price">
                    {{ price }}
                </span>
            </p>
        </div>
    </div>
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, PropType, defineComponent, onMounted } from 'vue';
    import { getBaggageLabel, getBaggagePrice } from '@shared/helpers/baggage';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { UpSellBaggage } from '@shared/interfaces/baggage';
    import { logStatsigCheckoutBaggageWarningOpen } from '@/tracking/statsig/checkout.functions';
    import { BaggageWarningPosition } from '@/tracking/statsig/types';

    export default defineComponent({
        name: 'BaggageWarning',
        methods: { t, getBaggageLabel, getMoneyObjectAsString },
        props: {
            isOneWay: {
                type: Boolean,
                default: false,
            },
            baggage: {
                type: Object as PropType<UpSellBaggage | null>,
                required: true,
            },
        },
        setup(props) {
            onMounted(() => {
                trackClarity(ClarityEvent.CHECKOUT_BAGGAGE_WARNING);
                logStatsigCheckoutBaggageWarningOpen(BaggageWarningPosition.Selection);
            });

            const price = computed(() => {
                if (props.baggage) {
                    const price = getBaggagePrice(
                        props.baggage.Price,
                        props.baggage.Leg,
                        props.isOneWay
                    );

                    const label = price.Split ? `${t({ key: 'shared.per_route' })}` : '';

                    return `${getMoneyObjectAsString(price.Price)} ${label}`;
                }
                return undefined;
            });

            return { price };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'BaggageWarning';
</style>
